import ReuseButton from "../../../fragments/ReuseButton";
import Select from "react-select";
import { formatNumWithCommaNairaSymbol } from "../../../utils/Helper";
import "../../styles/modal/upgradePlan.css";
import { useState } from "react";
// import { PatternFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { upgradeSubscription } from "../../../redux/subsciption/subscription";
import { Dna } from "react-loader-spinner";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import PhoneInput from "react-phone-input-2";

const UpgradePlan = ({
  onCancel,
  detail,
  planOption,
  planValue,
  onPlanChange,
  setSuccessModal,
  setShowModal,
  setUserDetails,
  currencyObj,
  selectActive,
  setSelectActive,
}) => {
  //   const planDetails = ["1-5 Users", "No Subsidiaries", "No Branches"];
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.subscription);

  const selectStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: "#ffff",
      border: "0.1rem solid rgba(0, 75, 255, 1)",
      //   border: state.isFocused ? "0.1rem solid rgba(0, 75, 255, 1)" : "#ffff",
      borderRadius: ".5rem",
      boxShadow: state.isFocused ? "rgb(0, 75, 255, 1)" : 0,
      "&:hover": null,
    }),
    container: (provided) => ({
      ...provided,
      fontWeight: "400",
    }),
    indicatorSeparator: () => null,
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "#000",
      "&:hover": null,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected && "rgb(0, 75, 255)",
    }),
  };

  const [activeSelect, setActiveSelect] = useState(false);

  const [details, setDetails] = useState({
    subscription_type: "",
    subscription_plan_id: "",
    user_id: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const data = { ...details, [name]: value };
    setDetails(data);
  };

  function validateEmail(email) {
    var filter =
      // eslint-disable-next-line no-useless-escape
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!filter.test(email)) {
      return false;
    } else {
      return true;
    }
  }

  const handleSubmit = async () => {
    const obj = {
      subscription_type: activeSelect ? "yearly" : "monthly",
      subscription_plan_id: planValue?.value,
      // user_id: user?.id,
      email: details?.email,
    };
    const data = await dispatch(upgradeSubscription(obj));
    if (!validateEmail(details?.email)) {
      toast.error("Invalid email address!", {
        theme: "colored",
        position: "top-right",
      });
      return;
    }
    if (data?.payload?.response?.status === 400) {
      toast.error("Current subscription still running!", {
        theme: "colored",
        position: "top-right",
      });
    }
    if (data?.payload?.status === 200) {
      setUserDetails(data?.payload?.data?.data);
      setSuccessModal(true);
      setShowModal(false);
    }
  };

  const checkBox = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx="10" cy="10" r="10" fill="#0E73F6" />
      <path
        d="M16.8 5.59961L8 14.3996L4 10.3996"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  return (
    <div className="upgrade-plan-wrap">
      <div className="upgrade-plan-container">
        <p className="upgrade-title">Subscription Plan</p>
        <p className="cancel-icon" onClick={onCancel}>
          {cancelIcon}
        </p>

        {/* current plan wrap start */}
        <div className="current-plan-wrap">
          <label>Plan:</label>
          <Select
            styles={selectStyle}
            className="upgrade-select upgrade-active-select"
            placeholder="Current Plan"
            options={planOption}
            // onChange={(e) => {
            //   setPlanSelect((prev) => {
            //     return { ...prev, subscription_plan_id: e?.value };
            //   });
            // }}
            onChange={onPlanChange}
            value={planValue}
            isLoading={loading}
          />
        </div>
        {/* current plan wrap end */}
        {/* currency select start */}
        <div className="plan-content-wrap">
          {loading ? (
            <div style={{ marginBottom: "1rem" }}>
              <Skeleton width={100} height={`30%`} />
            </div>
          ) : (
            <p className="upgrade-amount">
              {`${
                !selectActive
                  ? formatNumWithCommaNairaSymbol(
                      Number(
                        planValue?.monthly_price || detail?.monthly_price
                      ) / Number(currencyObj?.rate),
                      currencyObj?.name
                    )
                  : formatNumWithCommaNairaSymbol(
                      Number(planValue?.yearly_price || detail?.yearly_price) /
                        Number(currencyObj?.rate),
                      currencyObj?.name
                    )
              } / ${!selectActive ? "Monthly" : "Yearly"}` || <>&nbsp;</>}
            </p>
          )}
          {/* date wrap start */}
          <div className="select-date-wrap">
            <p
              onClick={() => {
                setSelectActive(false);
              }}
              className={`select-date ${!selectActive && "active-select"}`}
            >
              Monthly
            </p>
            <p
              onClick={() => {
                setSelectActive(true);
              }}
              className={`select-date ${selectActive && "active-select"}`}
            >
              Yearly
            </p>
          </div>
          {/* date wrap end */}
        </div>
        {/* currency select end */}
        <div className="current-plan-container">
          {/* plan details wrap start */}
          <div className="plan-details-wrap">
            {loading ? (
              <Skeleton width={300} height={`10%`} />
            ) : (
              <p className="plan-title">
                {planValue?.description || detail?.description}
              </p>
            )}
            <div className="plan-details-container">
              {(planValue?.limited_to || detail?.limited_to)?.map(
                (chi, idx) => {
                  return (
                    <div key={idx} className="plan-details-box">
                      {loading ? (
                        <Skeleton width={20} circle={true} height={`30%`} />
                      ) : (
                        <figure className="check-box">{checkBox}</figure>
                      )}
                      {loading ? (
                        <Skeleton width={200} height={`30%`} />
                      ) : (
                        <p>{chi}</p>
                      )}
                    </div>
                  );
                }
              )}
            </div>
          </div>
          {/* plan details wrap end */}
        </div>
        {/* contact info start */}
        <div className="contact-info-wrap">
          {/* contact info box start */}
          <div>
            <label htmlFor="email" className="contact-label">
              Work Email
            </label>
            <input
              className={`contact-input ${
                details?.email && "contact-input-active"
              }`}
              type="email"
              name="email"
              id="email"
              value={details?.email}
              onChange={handleChange}
            />
          </div>
          {/* contact info box end */}

          {/* contact info box start */}
          {/* <div>
          <label className="contact-label">Phone Number</label>
          <PatternFormat
            type="text"
            className="contact-input"
            id="contact line"
            name="contact_line"
            format="### ### ### ###"
            value={details?.phone_number}
          />
        </div> 
          {/* contact info box end */}

          {/* btn wrap start */}
          <div className="upgrade-btn">
            {loading ? (
              <Dna
                visible={true}
                height="50"
                width="100"
                ariaLabel="dna-loading"
                wrapperClass="dna-wrapper"
              />
            ) : (
              <ReuseButton
                bgColor={details?.email ? " rgba(0, 75, 255, 1)" : "#ccc"}
                text={"Subscribe"}
                onClick={details?.email && handleSubmit}
                style={{ cursor: !details?.email ? "not-allowed" : "" }}
              />
            )}
          </div>
          {/* btn wrap end */}
        </div>
        {/* contact info end */}
      </div>
    </div>
  );
};
export default UpgradePlan;

export const cancelIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8332 5.34199L14.6582 4.16699L9.99984 8.82533L5.3415 4.16699L4.1665 5.34199L8.82484 10.0003L4.1665 14.6587L5.3415 15.8337L9.99984 11.1753L14.6582 15.8337L15.8332 14.6587L11.1748 10.0003L15.8332 5.34199Z"
      fill="#CC0905"
    />
  </svg>
);
